import { render, staticRenderFns } from "./LoginPageFrame.vue?vue&type=template&id=71294d5a&scoped=true"
import script from "./LoginPageFrame.vue?vue&type=script&lang=js"
export * from "./LoginPageFrame.vue?vue&type=script&lang=js"
import style0 from "./LoginPageFrame.vue?vue&type=style&index=0&id=71294d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71294d5a",
  null
  
)

export default component.exports